import { lazy } from 'react';

const MTSwitchCompany = lazy(() => import('./MTSwitchCompany.component'));

export default MTSwitchCompany;
